import { db } from "@/firebase/init.js";
import {
  collection,
  query,
  orderBy,
  getDoc,
  doc,
  getDocs,
  setDoc,
  deleteDoc,
  updateDoc,
} from "firebase/firestore";

const bannersModule = {
  namespaced: true,
  state: {
    bannersList: [],
    updateBanner: {},
    isLoading: true,
    isFirstLoad: true,
  },
  getters: {
    getBanners: (state) => state.bannersList,
    isLoading: (state) => state.isLoading,
    isFirstLoad: (state) => state.isFirstLoad,
  },
  mutations: {
    // Loading
    setLoading: (state, payload) => {
      state.isLoading = payload;
    },

    // First load
    setFirstLoad: (state, payload) => {
      state.isFirstLoad = payload;
    },

    // Get All Banners
    setBanners: (state, payload) => {
      state.bannersList = payload;
    },
    // Add Banner
    addBanner: (state, payload) => {
      if (state.bannersList.length > 0) state.bannersList.unshift(payload);
      else state.bannersList = [payload];
    },
    // get Review by id
    getBannerById: (state, payload) => {
      state.updateBanner = state.bannersList.find(
        (banner) => banner.banner_id == payload
      );
    },
    // Update Banner
    updateBanner: (state, payload) => {
      const findIndex = state.bannersList.findIndex(
        (banner) => banner.banner_id == payload.banner_id
      );
      state.bannersList[findIndex] = payload;
    },
    // Delete Banner
    deleteBanner: (state, payload) => {
      let filtered = state.bannersList.filter(function (value) {
        return value.banner_id != payload;
      });
      state.bannersList = filtered;
    },
  },
  actions: {
    // Get All Banners
    async fetchBanners({ commit }) {
      commit("setLoading", true);
      commit("setFirstLoad", true);
      const bannersList = await getDocs(
        query(collection(db, "Banners"), orderBy("created_date", "desc"))
      );
      let bannerArray = [];
      if (!bannersList.empty) {
        bannersList.forEach((doc) => {
          bannerArray.push({ ...doc.data(), banner_id: doc.id });
        });
      } else {
        console.log("No Banners found");
        bannerArray = false;
      }
      commit("setBanners", bannerArray);
      commit("setLoading", false);
      commit("setFirstLoad", false);
      return bannersList;
    },
    // Add Banner
    async addBanner({ commit }, payload) {
      const documentReference = doc(collection(db, "Banners"));
      const banner = {
        ...payload,
        banner_id: documentReference.id,
        created_date: new Date(),
      };
      setDoc(documentReference, banner);
      commit("addBanner", banner);
    },
    // Get Banner by id
    async getBannerById({ commit }, payload) {
      let banner = await getDoc(doc(db, "Banners", payload));
      commit("getBannerById", banner);
      return banner.data();
    },
    // Update Banner
    async updateBanner({ commit }, payload) {
      updateDoc(doc(db, "Banners", payload.banner_id), payload);
      commit("updateBanner", payload);
    },
    // Delete Banner
    async deleteBanner({ commit }, payload) {
      deleteDoc(doc(db, "Banners", payload));
      commit("deleteBanner", payload);
    },
  },
};

export default bannersModule;
